import { Button, Grid, Stack, Typography } from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import NewsTable from 'components/News/Table'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function News() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: '新着情報管理',
          url: '/news',
        },
      ])
    )
  }, [dispatch])
  return (
    <Grid container spacing={1} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ borderBottom: 2 }}
        >
          新着情報管理
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack
          direction={{
            xs: 'column',
            md: 'row',
          }}
          spacing={1}
          alignItems={{
            xs: 'flex-start',
            md: 'center',
          }}
          justifyContent="space-between"
          my={2}
        >
          <Typography variant="h6" component="h3" fontWeight="bold" ml={1}>
            新着情報一覧
          </Typography>
          <Link to="/news/register">
            <Button
              color="secondary"
              variant="contained"
              sx={{
                px: 6,
                borderColor: '#aaa',
                borderRadius: 2,
              }}
            >
              新規登録
            </Button>
          </Link>
        </Stack>
        <NewsTable />
      </Grid>
    </Grid>
  )
}
